import React from 'react';
import { Box } from 'rebass';
import Details from '../../Details';
import Link from '../../app/components/link';
import Slider from '../../app/components/slider';
import Lead from '../../Lead';
import image1 from '../../app/data/screenshots/llanoseco/pork.jpg';
import image2 from '../../app/data/screenshots/llanoseco/shop.jpg';
import image3 from '../../app/data/screenshots/llanoseco/gallery.jpg';
import image4 from '../../app/data/screenshots/llanoseco/news.jpg';

const images = [
  {
    src: image1,
    alt: 'Llano Seco products description',
  },
  {
    src: image2,
    alt: 'Llano Seco shop',
  },
  {
    src: image3,
    alt: 'Llano Seco gallery page',
  },
  {
    src: image4,
    alt: 'Llano Seco news page',
  },
];

const tags = [
  'Consumer Facing Website',
  'Design',
  'Javascript',
  'HTML',
  'CSS',
];

export default () => (
  <div>
    <Details
      title="Llano Seco Rancho"
      subtitle="Agriculture"
    >
      <Details.Paragraph emoji="🐄" title="A family farm, that is older than your great grandfather">
        <Link target="_blank" href="https://llanoseco.com/">Llano Seco Rancho</Link> has been
        raising pigs and cattle, and growing beans and ancient grains since 1861! They
        wanted to create a website to promote their great products, as well as increase awareness
        on how they preserve and grow the diversity of animal and plant existence on the Rancho.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="A truly beautiful website">
        We were excited that Llano Seco approached us to work on such an interesting project. The
        ranch has a long and interesting history, and we love to help well-established
        business getting of the ground on the web, with an awesome website. The final result is
        a truly beautiful and unique website, as evident by the screenshots below.
      </Details.Paragraph>
      <Details.Tags tags={tags} />
      <Slider images={images} />
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/llanoseco.js